import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect(): void {
    this.flashNoticeTimeout()
  }

  dismiss(): void {
    this.element.remove();
  }

  private flashNoticeTimeout() {
    setTimeout(() => {
      this.hideFlashNotice()
    }, 3000)
  }

  private hideFlashNotice() {
    this.element.remove()
  }
}
